import React from 'react';
import { caseLockStatus } from '@store/actions/CaseDetailsActionCreators';
import { useDispatch, useSelector } from 'react-redux';
import { useCaseDetailsPageContext } from '@components/CaseDetails/CaseDetailsContext/CaseDetailsPageContext/CaseDetailsPageContext';
import { ManageCaseOption } from '@components/CaseDetails/ManageCaseDropDown/ManageCaseOption';
import {
	useCaseDetailsInfoContext
} from '@components/CaseDetails/CaseDetailsContext/CaseDetailsInfoContext/CaseDetailsInfoContext';
import { CaseDetailsAppointmentSelector, CaseDetailsInfoSelector, IsCaseDetailsLockedSelector } from '@store/selectors/CaseDetailsSelector';
import { RenderAsProps } from '@components/CaseDetails/ManageCaseDropDown/DropDownOptions/DropDownOptionProps';
import { useModalContext } from '@components/Modal/ModalContextProvider';
import { CASE_LOCK_MODAL } from '@components/Modal/modalConstants';
import CaseStatus from '@interfaces/CaseStatus';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { useCollectionEntity } from '@utilities/hooks/useCollectionEntity/useCollectionEntity';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';
import { Unit } from '@data/unit/Unit';

export const EditCaseOption = ({ closeDropdown }: RenderAsProps) => {
	const { ssmuiSignedUrl } = useSsmUiFlags();
	const { caseId } = useCaseDetailsInfoContext();
	const { status } = useSelector(CaseDetailsAppointmentSelector);
	const { unit } = useSelector(CaseDetailsInfoSelector);
	const lockStatus = useSelector(IsCaseDetailsLockedSelector);
	const unitDetails = useCollectionEntity<Unit>(ENDPOINT_USER_UNITS, unit, 'id') as Unit;
	const unitHasSchedulingDisabled = Boolean(unitDetails?.disableScheduling);
	const isPendingCancelled = status && status === CaseStatus.PENDING_CANCELLED;
	const isCancelled = status && status === CaseStatus.CANCELLED;
	const isCancelledAndNotSignedUrl = isCancelled && !ssmuiSignedUrl;
	const disableOption = !!(lockStatus || isPendingCancelled || isCancelledAndNotSignedUrl);
	const { showEdit } = useCaseDetailsPageContext();
	const dispatch = useDispatch();
	const { openModal } = useModalContext();

	const attemptOpenEdit = () => {
		dispatch(caseLockStatus(caseId, true, {
			onSuccess: () => {
				showEdit();
			},
			onFailure: () => openModal(CASE_LOCK_MODAL)
		}));
		closeDropdown();
	};

	if (unitHasSchedulingDisabled) {
		return null;
	}

	return (
		<ManageCaseOption onClick={attemptOpenEdit} fieldName="editCase" disabled={disableOption}>
			{ isCancelled ? 'Reschedule' : 'Edit' }
		</ManageCaseOption>
	);
};
